
import React, { useState, useEffect } from 'react';
import Nav from '../Nav/Nav';
import Footer from '../Footer/Footer';

export default function Contact() {
  const [submitted, setSubmitted] = useState(false);
  const [isDesktop, setIsDesktop] = useState(
    typeof window !== 'undefined' ? window.innerWidth >= 768 : true
  );

  const [form, setForm] = useState({
    name: '',
    email: '',
    mobile: '',
    service: '',
    destination: '',
    travelDate: '',
    message: '',
  });

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  const labelStyle = {
    display: 'block',
    fontSize: '11px',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    marginBottom: '6px',
    color: 'var(--text-muted, #718096)',
    fontFamily: 'Manrope, sans-serif',
  };

  const inputStyle = {
    width: '100%',
    padding: '10px 12px',
    borderRadius: '8px',
    fontSize: '14px',
    outline: 'none',
    boxSizing: 'border-box',
    border: '1.5px solid var(--border, #e2e8f0)',
    color: 'var(--navy, #0a192f)',
    fontFamily: 'Manrope, sans-serif',
    backgroundColor: '#ffffff',
  };

  const sectionLabelStyle = {
    fontSize: '13px',
    fontWeight: 700,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: 'var(--gold, #F47B20)',
    marginBottom: '12px',
    fontFamily: 'Manrope, sans-serif',
  };

  return (
    <>
      <Nav />
      <div style={{ minHeight: '100vh', background: 'var(--bg, #f8fafc)', fontFamily: 'Manrope, sans-serif' }}>
        {/* Hero */}
        <div
          style={{
            background: 'var(--navy, #0a192f)',
            paddingTop: '80px',
            paddingBottom: '48px',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              position: 'absolute',
              inset: 0,
              background: 'radial-gradient(circle at 60% 40%, rgba(244,123,32,0.12) 0%, transparent 60%)',
            }}
          />
          <div
            style={{
              position: 'relative',
              zIndex: 10,
              maxWidth: '1280px',
              margin: '0 auto',
              padding: '32px 24px',
              textAlign: 'center',
              boxSizing: 'border-box',
            }}
          >
            <p style={sectionLabelStyle}>Get In Touch</p>
            <h1
              style={{
                fontSize: isDesktop ? '48px' : '36px',
                fontWeight: 800,
                color: '#ffffff',
                marginBottom: '16px',
                marginTop: 0,
                fontFamily: 'Manrope, sans-serif',
              }}
            >
              Let's Plan Your Next Journey.
            </h1>
            <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '15px', margin: 0 }}>
              A travel consultant will respond within 2–4 business hours.
            </p>
          </div>
        </div>

        <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '48px 24px', boxSizing: 'border-box' }}>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: isDesktop ? '1fr 2fr' : '1fr',
              gap: '32px',
            }}
          >
            {/* Contact Info */}
            <div>
              <div
                style={{
                  borderRadius: '12px',
                  padding: '24px',
                  marginBottom: '16px',
                  background: 'var(--navy, #0a192f)',
                  border: '1px solid rgba(244,123,32,0.15)',
                }}
              >
                <p style={sectionLabelStyle}>Our Office</p>
                <p style={{ fontWeight: 700, color: '#ffffff', fontSize: '15px', marginBottom: '4px', marginTop: 0, fontFamily: 'Manrope, sans-serif' }}>
                  Aerova Travels Pvt. Ltd.
                </p>
                <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '13px', lineHeight: '1.6', marginBottom: '20px' }}>
                  402, Prestige Towers<br />
                  Road No. 12, Banjara Hills<br />
                  Hyderabad, Telangana 500034
                </p>

                {[
                  { icon: '📞', label: 'Phone', value: '+91 98765 43210' },
                  { icon: '📱', label: 'WhatsApp', value: '+91 98765 43210' },
                  { icon: '✉', label: 'Email', value: 'hello@aerova.in' },
                  { icon: '🕐', label: 'Business Hours', value: 'Mon–Sat: 9:00 AM – 7:00 PM' },
                ].map((c) => (
                  <div key={c.label} style={{ display: 'flex', gap: '12px', marginBottom: '16px' }}>
                    <span style={{ fontSize: '18px', marginTop: '2px' }}>{c.icon}</span>
                    <div>
                      <p style={{ fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '2px', marginTop: 0, color: 'rgba(255,255,255,0.4)', fontFamily: 'Manrope, sans-serif' }}>
                        {c.label}
                      </p>
                      <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.8)', margin: 0 }}>{c.value}</p>
                    </div>
                  </div>
                ))}

                <div style={{ marginTop: '20px', paddingTop: '20px', borderTop: '1px solid rgba(255,255,255,0.1)' }}>
                  <p style={{ fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '12px', marginTop: 0, color: 'rgba(255,255,255,0.4)', fontFamily: 'Manrope, sans-serif' }}>
                    GST Registration
                  </p>
                  <p style={{ fontSize: '12px', color: 'rgba(255,255,255,0.5)', fontFamily: 'monospace', margin: 0 }}>
                    36AAPCA1234A1ZX
                  </p>
                </div>
              </div>

              {/* Map Placeholder */}
              <div
                style={{
                  borderRadius: '12px',
                  overflow: 'hidden',
                  height: '176px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: 'var(--white, #ffffff)',
                  border: '1px solid var(--border, #e2e8f0)',
                }}
              >
                <div style={{ textAlign: 'center' }}>
                  <span style={{ fontSize: '30px', display: 'block', marginBottom: '8px' }}>🗺</span>
                  <p style={{ fontSize: '13px', fontWeight: 600, color: 'var(--navy, #0a192f)', fontFamily: 'Manrope, sans-serif', margin: 0 }}>
                    Banjara Hills, Hyderabad
                  </p>
                  <p style={{ fontSize: '12px', marginTop: '2px', marginBottom: 0, color: 'var(--text-muted, #718096)' }}>
                    Click to open in Google Maps
                  </p>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div>
              {submitted ? (
                <div
                  style={{
                    borderRadius: '16px',
                    padding: '40px',
                    textAlign: 'center',
                    background: 'var(--white, #ffffff)',
                    border: '1px solid var(--border, #e2e8f0)',
                    boxShadow: 'var(--card-shadow, 0 4px 20px rgba(0,0,0,0.05))',
                  }}
                >
                  <div
                    style={{
                      width: '64px',
                      height: '64px',
                      borderRadius: '16px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '30px',
                      margin: '0 auto 20px auto',
                      background: 'rgba(22,134,91,0.1)',
                      color: '#16865B',
                    }}
                  >
                    ✓
                  </div>
                  <h2
                    style={{
                      fontSize: '24px',
                      fontWeight: 800,
                      marginBottom: '12px',
                      marginTop: 0,
                      fontFamily: 'Manrope, sans-serif',
                      color: 'var(--navy, #0a192f)',
                    }}
                  >
                    Thank You, {form.name.split(' ')[0] || 'Traveller'}.
                  </h2>
                  <p style={{ fontSize: '15px', marginBottom: '16px', color: 'var(--text-secondary, #4a5568)' }}>
                    Your travel enquiry has been received.
                  </p>
                  <p style={{ fontSize: '14px', marginBottom: '24px', color: 'var(--text-secondary, #4a5568)' }}>
                    One of our travel experts will contact you within 2–4 business hours on <strong>{form.mobile || 'your registered number'}</strong>.
                  </p>
                  <div
                    style={{
                      display: 'inline-block',
                      padding: '12px 24px',
                      borderRadius: '12px',
                      fontSize: '13px',
                      fontWeight: 700,
                      background: 'var(--bg, #f8fafc)',
                      border: '1px solid var(--border, #e2e8f0)',
                    }}
                  >
                    <span style={{ fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', display: 'block', marginBottom: '4px', color: 'var(--text-muted, #718096)', fontFamily: 'Manrope, sans-serif' }}>
                      Request ID
                    </span>
                    <span style={{ fontFamily: 'monospace', fontSize: '15px', color: 'var(--navy, #0a192f)' }}>
                      ATV-ENQ-{Math.floor(Math.random() * 90000 + 10000)}
                    </span>
                  </div>
                  <div style={{ marginTop: '24px' }}>
                    <button
                      onClick={() => setSubmitted(false)}
                      style={{
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: '13px',
                        fontWeight: 600,
                        color: 'var(--royal, #0f2744)',
                        fontFamily: 'Manrope, sans-serif',
                      }}
                    >
                      ← Submit another enquiry
                    </button>
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    borderRadius: '16px',
                    padding: '32px',
                    background: 'var(--white, #ffffff)',
                    border: '1px solid var(--border, #e2e8f0)',
                    boxShadow: 'var(--card-shadow, 0 4px 20px rgba(0,0,0,0.05))',
                  }}
                >
                  <h2
                    style={{
                      fontSize: '20px',
                      fontWeight: 800,
                      marginBottom: '24px',
                      marginTop: 0,
                      fontFamily: 'Manrope, sans-serif',
                      color: 'var(--navy, #0a192f)',
                    }}
                  >
                    Send Us an Enquiry
                  </h2>
                  <form
                    onSubmit={handleSubmit}
                    style={{
                      display: 'grid',
                      gridTemplateColumns: isDesktop ? 'repeat(2, 1fr)' : '1fr',
                      gap: '16px',
                    }}
                  >
                    {[
                      { label: 'Full Name', key: 'name', type: 'text', placeholder: 'Priya Sharma' },
                      { label: 'Email Address', key: 'email', type: 'email', placeholder: 'priya@example.com' },
                      { label: 'Mobile Number', key: 'mobile', type: 'tel', placeholder: '+91 98765 43210' },
                      { label: 'Destination', key: 'destination', type: 'text', placeholder: 'e.g. Kashmir, UK, Goa' },
                    ].map((field) => (
                      <div key={field.key}>
                        <label style={labelStyle}>{field.label}</label>
                        <input
                          type={field.type}
                          placeholder={field.placeholder}
                          value={form[field.key]}
                          onChange={(e) => setForm({ ...form, [field.key]: e.target.value })}
                          style={inputStyle}
                          required={field.key === 'name' || field.key === 'mobile'}
                        />
                      </div>
                    ))}

                    <div>
                      <label style={labelStyle}>Service Required</label>
                      <select
                        value={form.service}
                        onChange={(e) => setForm({ ...form, service: e.target.value })}
                        style={inputStyle}
                      >
                        <option value="">Select service</option>
                        <option>Flight Tickets</option>
                        <option>Tours / Holidays</option>
                        <option>Visa Consultancy</option>
                        <option>Corporate Travel</option>
                        <option>Hotels</option>
                      </select>
                    </div>

                    <div>
                      <label style={labelStyle}>Travel Date</label>
                      <input
                        type="date"
                        value={form.travelDate}
                        onChange={(e) => setForm({ ...form, travelDate: e.target.value })}
                        style={inputStyle}
                      />
                    </div>

                    <div style={{ gridColumn: isDesktop ? 'span 2' : 'auto' }}>
                      <label style={labelStyle}>Message / Requirements</label>
                      <textarea
                        rows={4}
                        placeholder="Tell us about your travel plans, number of travellers, budget, special requirements..."
                        value={form.message}
                        onChange={(e) => setForm({ ...form, message: e.target.value })}
                        style={{ ...inputStyle, resize: 'none' }}
                      />
                    </div>

                    <div style={{ gridColumn: isDesktop ? 'span 2' : 'auto' }}>
                      <button
                        type="submit"
                        style={{
                          width: '100%',
                          padding: '14px 0',
                          borderRadius: '12px',
                          fontSize: '15px',
                          fontWeight: 700,
                          border: 'none',
                          cursor: 'pointer',
                          background: 'var(--gold, #F47B20)',
                          color: 'var(--navy, #0a192f)',
                          fontFamily: 'Manrope, sans-serif',
                        }}
                      >
                        Send Enquiry
                      </button>
                      <p style={{ textAlign: 'center', fontSize: '12px', marginTop: '12px', marginBottom: 0, color: 'var(--text-muted, #718096)' }}>
                        By submitting, you agree to our privacy policy. We do not share your information with third parties.
                      </p>
                    </div>
                  </form>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}